import { TimeSection, DeliveryEligibility } from '../types'

/**
 * Mapping of time sections to delivery eligibility
 */
export const ELIGIBILITY_MAP: Record<TimeSection, DeliveryEligibility> = {
  FRI_MORNING: 'NDD',
  SAT_MORNING: 'NDD',
  SUN_MORNING: 'NDD',
  MON_MORNING: 'NDD',
  TUE_MORNING: 'NDD',
  WED_MORNING: '3DD+',
  THU_MORNING: '2DD_NO_EMERGENCY',
  FRI_AFTERNOON: '2DD',
  SAT_AFTERNOON: '2DD',
  SUN_AFTERNOON: '2DD',
  MON_AFTERNOON: '2DD',
  TUE_AFTERNOON: '3DD+',
  WED_AFTERNOON: '3DD+',
  THU_AFTERNOON: '2DD_NO_EMERGENCY',
}
